import React, { Fragment, useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import { apiData } from "../../../actions";
import DataLoader from "../../../Utils/DataLoader";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import location from '../../../assets/images/location.svg'

const formatTitle = (title = "") =>
    title.length >= 25 ? `${title.slice(0, 38)}..` : title;

export default function ExcitementSeeking() {
    const place = useSelector((state) => state.place);
    const formattedPlace = place?.replace(/\b\w/g, (x) => x.toUpperCase());

    const [adrenalineData, setAdrenalineData] = useState([]);
    const [allAdrenalineData, setAllAdrenalineData] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);

    // NEW STATE 🟢
    const [seeMoreModal, setSeeMoreModal] = useState(false);
    const [seeMoreLoading, setSeeMoreLoading] = useState(false);

    const fetchAdrenalineData = async () => {
        let payload = {
            city: place,
            keyword: "tour",
            limit: 10,
        }
        setPageLoading(true);
        try {
            const res = await apiData.getAdrenalineRush(payload);
            const resultList = res?.data?.data?.data?.products?.resultList || [];
            setAdrenalineData(resultList);
        } catch (error) {
            console.error("Error fetching adrenaline rush data:", error);
            setAdrenalineData([]);
        } finally {
            setPageLoading(false);
        }
    };


    // 🟢 FIXED VERSION
    const handleSeeAllClick = async () => {
        setSeeMoreModal(true);
        setSeeMoreLoading(true);
        let payload = {
            city: place,
            keyword: "tour",
            limit: "",
        }

        try {
            // Step 1 → First API (just to get total count)
            const initialRes = await apiData.getAdrenalineRush(payload);
            const totalCount = initialRes?.data?.data?.data?.products?.totalCount || 0;

            if (totalCount === 0) {
                setAllAdrenalineData([]);
                return;
            }

            // Step 2 → Fetch all records
            const fullRes = await apiData.getAdrenalineRush(payload);
            const resultList = fullRes?.data?.data?.data?.products?.resultList || [];

            let finalList = [];

            if (place) {
                finalList = resultList.filter(
                    (item) => item?.customLabel3?.toLowerCase() === place.toLowerCase()
                );
            } else {
                finalList = resultList;
            }

            setAllAdrenalineData(finalList);
        } catch (err) {
            console.error("Error fetching all adrenaline data", err);
            setAllAdrenalineData([]);
        } finally {
            setSeeMoreLoading(false); // 🟢 Do NOT close modal
        }
    };

    useEffect(() => {
        fetchAdrenalineData();
    }, [place]);

    if (pageLoading) return <DataLoader />;
    return (
        <section className="section-equal-padding  owl-nav-left">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="section-top-heading mb-3 mb-md-5 "
                            uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                            <h2 className="mb-2 text-black">Excitement-Seeking</h2>
                            <p>
                                Get set for an awesome vacation! Explore sightseeing tours, bus excursions, and exclusive
                                passes. Uncover hidden gems, create memorable moments, and elevate your trip. Time to make
                                the most of it – book your tours now and let the adventure begin!
                            </p>
                        </div>
                    </div>
                </div>
                <div className="" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                    {adrenalineData.length > 0 ? (
                        <>
                            <Swiper
                                modules={[Navigation, Autoplay]}
                                spaceBetween={20}
                                loop={true}
                                autoplay={{
                                    delay: 3000,
                                    disableOnInteraction: false,
                                }}
                                navigation={true}
                                breakpoints={{
                                    0: { slidesPerView: 1 },
                                    768: { slidesPerView: 2 },
                                    992: { slidesPerView: 3 },
                                    1400: { slidesPerView: 4 },
                                }}
                                className="pb-70 excitement-swiper"
                                >
                                {adrenalineData.map((ele, index) => (
                                    <SwiperSlide key={index} className="">
                                        <div
                                            className="resorts-box p-3 bg-white"
                                        >
                                            <figure>
                                                <img loading="lazy"
                                                    src={ele.imageLink}
                                                    alt={ele.title}
                                                    className="img-fluid" />
                                            </figure>
                                            <div className="resorts-content-box">
                                                <div className="d-flex justify-content-between">
                                                    {/* <span className="rating-star"><i className="fa-solid fa-star"></i> 4.8 Overall
                                        Reviews</span> */}
                                                    <span className="d-flex gap-1">
                                                        <img src={location} alt="location" width={20} height={20} />
                                                        {ele.customLabel3 || formattedPlace}
                                                    </span>

                                                </div>
                                                <div className="resort-description">
                                                    <h3>{formatTitle(ele.title)}</h3>
                                                    <p>{formatTitle(ele.description)}</p>
                                                </div>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="price-label">
                                                        {(ele?.price?.amount !== ele?.salePrice?.amount && ele?.price?.amount > ele?.salePrice?.amount) && (
                                                            <span className="old-price">${ele?.price?.amount}</span>
                                                        )}{" "}
                                                        <span>${ele?.salePrice?.amount ? ele?.salePrice?.amount : ele?.price?.amount}</span>
                                                    </div>
                                                    {(ele?.price?.amount !== ele?.salePrice?.amount && ele?.price?.amount > ele?.salePrice?.amount) && (
                                                        <span className="off-span">
                                                            {(() => {
                                                                const originalPrice = Number(ele?.price?.amount);
                                                                const salePrice = Number(ele?.salePrice?.amount);
                                                                const discount =
                                                                    originalPrice && salePrice
                                                                        ? Math.max(0, Math.round(((originalPrice - salePrice) / originalPrice) * 100))
                                                                        : 0;
                                                                return `-${discount}%`;
                                                            })()}
                                                        </span>
                                                    )}
                                                    <div className="book-trip-btn"><a className="flex flex-row" href={ele.link} target="_blank" rel="noreferrer">Book Trip <i
                                                        className="fa-solid fa-arrow-right"></i></a></div>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide >
                                ))}
                            </Swiper>

                            <div className="d-flex justify-content-end mt--45">
                                <button className="view-all-btn" onClick={handleSeeAllClick}>View All<i className="fa-solid fa-arrow-right"></i></button>
                            </div>
                        </>
                    ) : (
                        <p className="no_data_text">
                            Oops! No Data Available{" "}
                            <strong>{`For ${formattedPlace}`}</strong>
                        </p>
                    )}
                </div>
            </div>
            <Modal
                show={seeMoreModal}
                onHide={() => setSeeMoreModal(false)}
                centered
                className="modal_xl see-pop"
                size="xxl"
            >
                <Modal.Header closeButton>
                    <Modal.Title>All Excitement-seeking Activities</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {seeMoreLoading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary"></div>
                            <p className="mt-3 text-secondary">Loading content...</p>
                        </div>
                    ) : allAdrenalineData.length > 0 ? (
                        <div className="row">
                            {allAdrenalineData.map((ele, index) => (
                               <div className="col-12 col-sm-6 col-md-6 col-lg-4 mb-4">
                                   <a key={index} className="resorts-box p-3 bg-white d-inline-block w-100" href={ele.link} target="_blank" rel="noreferrer">
                                    <figure>
                                        <img loading="lazy" src={ele.imageLink} alt={ele.title} />
                                    </figure>
                                    <div className="resorts-content-box pt-0">
                                        <div className="resort-description">
                                            <h3>{formatTitle(ele.title)}</h3>
                                            <span>{formatTitle(ele.description)}</span>
                                        </div>

                                        <div className="d-flex justify-content-between mt-2">
                                            <div className="price-label"><span>${ele.price.amount}</span></div>
                                            <span className="d-flex gap-1">
                                                <img src={location} alt="location" />
                                                {ele.customLabel3 || formattedPlace}
                                            </span>
                                        </div>
                                    </div>


                                </a>
                               </div>
                            ))}
                        </div>
                    ) : (
                        <p className="text-center">No Data Found</p>
                    )}
                </Modal.Body>
            </Modal>
        </section>
    );
}